import { GlobalError } from "components/Error/GlobalError";
import type { PickState } from "features/container/types";

type Props = Pick<PickState<"ERROR">, "context" | "error"> & {
  branchId: string;
};

export const ContainerError: React.FC<Props> = ({
  context,
  error,
  branchId,
}) => {
  return (
    <GlobalError
      context={{
        branchId: branchId,
        error: error,
        event: context.event,
        state: context.state,
      }}
      errorCode="MICROVM_NOT_STARTED"
    />
  );
};
